export default __webpack_public_path__ + "static/media/dreamel.d4ad8dec.png";